module.exports = __webpack_public_path__ + "media/customizations/riverland/back-16b860eadfe8237ed47dc77de753812a.jpg";